import instance from "../api-provider";
import handleError from "../handleError";

export const getProviderSMSConversation = async (payload, token) => {
  try {
    let response = await instance({
      url: "/sms/getProviderSMSConversation",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const sendProviderSMS = async (payload, token) => {
  try {
    let response = await instance({
      url: "/sms/sendProviderSMS",
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const sendMessage = async (payload, token) => {
  try {
    let response = await instance({
      url: `/member/sendMessage`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};
